export const ACCEPTED_EXTENSIONS = [
  '.csv',
  '.xls',
  '.xlsx',
  '.xlsm',
  '.xlt',
  '.xltx',
  '.xltm',
  '.xla',
  '.xlam'
]

export const CSV_EXTENSION = 'csv'
